import {Component, Input} from '@angular/core';
import {RatingLabel, RatingLabels} from '../../model/rating-labels.model';
import {PreferredCategories} from '../../model/portfolio-preferences.model';

@Component({
    selector: 'app-selected-preferences',
    templateUrl: './selected-preferences.component.html',
    styleUrls: ['./selected-preferences.component.scss']
})
export class SelectedPreferencesComponent {
    public selectedPreferences: RatingLabels;

    @Input()
    set preferredCategories(categories: PreferredCategories[]) {
        this.onPreferredCategoriesReceived(categories);
    }

    onPreferredCategoriesReceived(preferredCategories: PreferredCategories[]) {
        this.selectedPreferences = RatingLabels.defaults()
            .filter(ratingLabel => this.isSelected(ratingLabel, preferredCategories));
    }

    isSelected(preference: RatingLabel, preferredCategories: PreferredCategories[]): boolean {
        return !!preferredCategories.find(selectedPreference => {
            return preference.value.ratingList.every(r => {
                return selectedPreference.ratingList.map(value => value.toString()).includes(r);
            });
        });
    }
}